import type { LanguageKey } from "@/shared/common/enums";
import { useTranslation } from "react-i18next";

export const useTranslationExists = () => {
  const { t, i18n: { language } } = useTranslation();

  const exists = (key: string, options: Record<string, unknown> = {}): boolean => {
    const translated = t(key, { ...options, defaultValue: "__MISSING__" });
    return translated !== "__MISSING__";
  };

  return { t, exists, lang: language as LanguageKey };
};
